import { Model } from 'app/model/backendmodel';
import { ColumnFlattenSettings } from 'app/model/pipeline/column-flatten-settings';
import { AdapterRegistry } from '../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { ValueAdapter } from '../value.adapter';
import { stringIsNullOrEmpty } from 'app/shared/utils/string.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ColumnFlattenSettings),
    adapts: {
        treatArrayAsString: '*',
        treatStructAsString: '*',
        flattenColumnDelimiter: '*'
    }
})
export class ColumnFlattenSettingsAdapter {
    public toResource(columnFlattenSettings: ColumnFlattenSettings): Model.ActivityColumnFlattenSettings {
        const modelColumnFlattenSettings: Model.ActivityColumnFlattenSettings = {
            treatArrayAsString: ValueAdapter.toResource(columnFlattenSettings, ColumnFlattenSettings.TREAT_ARRAY_AS_STRING),
            treatStructAsString: ValueAdapter.toResource(columnFlattenSettings, ColumnFlattenSettings.TREAT_STRUCT_AS_STRING),
        };
        if (!columnFlattenSettings.treatStructAsString || !stringIsNullOrEmpty(ColumnFlattenSettings.TREAT_STRUCT_AS_STRING.templateValue(columnFlattenSettings))) {
            modelColumnFlattenSettings.flattenColumnDelimiter = ValueAdapter.toResource(columnFlattenSettings, ColumnFlattenSettings.FLATTEN_COLUMN_DELIMITER);
        }
        return modelColumnFlattenSettings;
    }

    public toModel(modelActivityPolicy: Model.ActivityColumnFlattenSettings): ColumnFlattenSettings {
        const columnFlattenSettings: ColumnFlattenSettings = new ColumnFlattenSettings();
        ValueAdapter.toModel(columnFlattenSettings, ColumnFlattenSettings.TREAT_ARRAY_AS_STRING, modelActivityPolicy.treatArrayAsString);
        ValueAdapter.toModel(columnFlattenSettings, ColumnFlattenSettings.TREAT_STRUCT_AS_STRING, modelActivityPolicy.treatStructAsString);
        ValueAdapter.toModel(columnFlattenSettings, ColumnFlattenSettings.FLATTEN_COLUMN_DELIMITER, modelActivityPolicy.flattenColumnDelimiter);

        return columnFlattenSettings;
    }
}
